import { storeLink } from '../utils/storeLink';

const STORE_COLORS = {
  Coles:              { bg: '#e8001d', light: '#fff5f5', text: '#fff' },
  Woolworths:         { bg: '#007837', light: '#f0faf4', text: '#fff' },
  Aldi:               { bg: '#003087', light: '#f0f4ff', text: '#fff' },
  'Chemist Warehouse': { bg: '#e60000', light: '#fff5f5', text: '#fff' },
};


function DealCard({ deal, onAddToList, inList, isFavourited, onToggleFavourite }) {
  const colors  = STORE_COLORS[deal.store] || { bg: '#64748b', light: '#f8fafc', text: '#fff' };
  const savings = deal.originalPrice ? (deal.originalPrice - deal.salePrice).toFixed(2) : null;
  const link    = deal.url || storeLink(deal);

  const saleDate = deal.catalogueDate
    ? new Date(deal.catalogueDate + 'T00:00:00').toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' })
    : null;

  return (
    <div className="deal-card" style={{ borderTopColor: colors.bg }}>
      <div className="deal-card-store" style={{ backgroundColor: colors.bg, color: colors.text }}>
        {deal.store}
        {deal.discount && (
          <span className="deal-badge">{deal.discount}% OFF</span>
        )}
      </div>

      {onToggleFavourite && (
        <button
          className={`deal-fav-btn ${isFavourited ? 'deal-fav-btn--on' : ''}`}
          onClick={e => { e.stopPropagation(); onToggleFavourite(deal); }}
          title={isFavourited ? 'Remove from favourites' : 'Save — notify me when on sale again'}
          aria-label={isFavourited ? 'Unfavourite' : 'Favourite'}
        >
          {isFavourited ? '♥' : '♡'}
        </button>
      )}

      {deal.image && (
        <div className="deal-card-image-wrap">
          <img
            src={deal.image}
            alt={deal.name}
            className="deal-card-image"
            loading="lazy"
            decoding="async"
            onError={e => { e.target.style.display = 'none'; }}
          />
        </div>
      )}

      <div className="deal-card-body">
        <p className="deal-card-name">{deal.name}</p>

        {saleDate && (
          <p className="deal-card-sale-date">🗓 On sale {saleDate}</p>
        )}

        <div className="deal-card-prices">
          {deal.originalPrice && (
            <span className="deal-price-was">${deal.originalPrice.toFixed(2)}</span>
          )}
          <span className="deal-price-now">${deal.salePrice.toFixed(2)}</span>
          {savings && (
            <span className="deal-price-save">Save ${savings}</span>
          )}
        </div>

        <div className="deal-card-actions">
          <button
            className={`deal-btn-add ${inList ? 'deal-btn-add--added' : ''}`}
            onClick={() => onAddToList(deal)}
            disabled={inList}
            title={inList ? 'Already in your list' : 'Add to shopping list'}
          >
            <span className="deal-btn-icon">{inList ? '✓' : '+'}</span>
            <span className="deal-btn-text">{inList ? 'In list' : 'Add to list'}</span>
          </button>
          {link && (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="deal-btn-view"
              title="View on store website"
            >
              <span className="deal-btn-icon">↗</span>
              <span className="deal-btn-text">View</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default DealCard;
